import moment from "moment";
import { IAddCustomer } from "../../models/forms/IAddCustomerManagement";

export const initialState: IAddCustomer = {
  FirstName: "",
  LastName: "",
  FirstNameKana: "",
  LastNameKana: "",
  Dob: "",
  Gender: "2",
  Phone1: "",
  Phone2: "",
  Email: "",
  PostalCode: "",
  Address: "",
  PrefectureName: "",
  DianaCode: "",
  AppMemberShipCode: "",
  Referer: -1,
  IsBlocked: false,
  Memo: "",
  DmDshs: 'true',
  Password: "",
  ConfirmPassword: "",
  CustomerType: 0,
  RegisteredBy: 0,
  StoreId: undefined,
  UserId: undefined,
  CustomerMotiveList: [],
  MotivationOptions: [],
  IsOverwriteEmail: false,
  Status: "1",
  DobYear: -1,
  DobMonth: -1,
  DobDate: -1,
};
